export const BRAZIL_TIMEZONE = 'America/Sao_Paulo'

export const BRAZIL_LOCALE = 'pt-br'

export const BANK_HOLIDAYS = [
  // 2018 - Source: http://www.portaldefinancas.com/feriados2018.htm
  '2018-01-01',
  '2018-01-12',
  '2018-02-13',
  '2018-03-30',
  '2018-04-01',
  '2018-04-21',
  '2018-05-01',
  '2018-05-31',
  '2018-09-07',
  '2018-10-12',
  '2018-11-02',
  '2018-11-15',
  '2018-12-25',
  // 2019 - Source: http://www.portaldefinancas.com/feriados2019.htm
  '2019-01-01',
  '2019-03-04',
  '2019-03-05',
  '2019-04-19',
  '2019-04-21',
  '2019-05-01',
  '2019-06-20',
  '2019-09-07',
  '2019-10-12',
  '2019-11-02',
  '2019-11-15',
  '2019-12-25',
  // Source-http-/www'portaldefinancas.com/feriados2020.htm
  '2020-01-01',
  '2020-02-24',
  '2020-02-25',
  '2020-04-10',
  '2020-04-12',
  '2020-04-21',
  '2020-05-01',
  '2020-06-11',
  '2020-09-07',
  '2020-10-12',
  '2020-11-02',
  '2020-11-15',
  '2020-12-25',
  // Source: http://www.anbima.com.br/feriados/fer_nacionais/2021.asp
  '2021-01-01',
  '2021-02-15',
  '2021-02-16',
  '2021-04-02',
  '2021-04-21',
  '2021-05-01',
  '2021-06-03',
  '2021-09-07',
  '2021-10-12',
  '2021-11-02',
  '2021-11-15',
  '2021-12-25',
  // Source: http://www.anbima.com.br/feriados/fer_nacionais/2022.asp
  '2022-01-01',
  '2022-02-22',
  '2022-03-01',
  '2022-04-15',
  '2022-04-21',
  '2022-05-01',
  '2022-06-16',
  '2022-09-07',
  '2022-10-12',
  '2022-11-02',
  '2022-11-15',
  '2022-12-25',
  // Source: http://www.anbima.com.br/feriados/fer_nacionais/2023.asp
  '2023-01-01',
  '2023-02-20',
  '2023-02-21',
  '2023-04-07',
  '2023-04-21',
  '2023-05-01',
  '2023-06-08',
  '2023-09-07',
  '2023-10-12',
  '2023-11-02',
  '2023-11-15',
  '2023-12-25',
  // Source: http://www.anbima.com.br/feriados/fer_nacionais/2024.asp
  '2024-01-01',
  '2024-02-12',
  '2024-02-13',
  '2024-03-29',
  '2024-04-21',
  '2024-05-01',
  '2024-05-30',
  '2024-09-07',
  '2024-10-12',
  '2024-11-02',
  '2024-11-15',
  '2024-12-25',
  // Source: https://www.anbima.com.br/feriados/fer_nacionais/2025.asp
  '2025-01-01',
  '2025-03-03',
  '2025-03-04',
  '2025-04-18',
  '2025-04-21',
  '2025-05-01',
  '2025-06-19',
  '2025-09-07',
  '2025-10-12',
  '2025-11-02',
  '2025-11-15',
  '2025-12-25',
  // Source: https://www.anbima.com.br/feriados/fer_nacionais/2026.asp
  '2026-01-01',
  '2026-02-16',
  '2026-02-17',
  '2026-04-03',
  '2026-04-21',
  '2026-05-01',
  '2026-06-04',
  '2026-09-07',
  '2026-10-12',
  '2026-11-02',
  '2026-11-15',
  '2026-12-25',
  // Source: https://www.anbima.com.br/feriados/fer_nacionais/2027.asp
  '2027-01-01',
  '2027-02-08',
  '2027-02-09',
  '2027-03-26',
  '2027-04-21',
  '2027-05-01',
  '2027-05-27',
  '2027-09-07',
  '2027-10-12',
  '2027-11-02',
  '2027-11-15',
  '2027-12-25',
  // Source: https://www.anbima.com.br/feriados/fer_nacionais/2028.asp
  '2028-01-01',
  '2028-02-28',
  '2028-02-29',
  '2028-04-14',
  '2028-04-21',
  '2028-05-01',
  '2028-06-15',
  '2028-09-07',
  '2028-10-12',
  '2028-11-02',
  '2028-11-15',
  '2028-12-25',
  // Source: https://www.anbima.com.br/feriados/fer_nacionais/2029.asp
  '2029-01-01',
  '2029-02-12',
  '2029-02-13',
  '2029-03-30',
  '2029-04-21',
  '2029-05-01',
  '2029-05-31',
  '2029-09-07',
  '2029-10-12',
  '2029-11-02',
  '2029-11-15',
  '2029-12-25',
  // Source: https://www.anbima.com.br/feriados/fer_nacionais/2030.asp
  '2030-01-01',
  '2030-03-04',
  '2030-03-05',
  '2030-04-19',
  '2030-04-21',
  '2030-05-01',
  '2030-06-20',
  '2030-09-07',
  '2030-10-12',
  '2030-11-02',
  '2030-11-15',
  '2030-12-25'
]
